import React from 'react';
import { Bot, Zap } from 'lucide-react';
import { AI_ASSISTANT_NAME, AI_MODE, AI_MODE_LABELS } from '../../constants/aiAssistant';

/**
 * Shows the current Kai mode (Copilot vs CoWorker) so users always know
 * whether they are in "suggest & approve" or "autonomous" mode.
 * Use on AI/agent pages and work queue views.
 *
 * @param {string} mode - 'copilot' | 'coworker'
 * @param {string} [serviceName] - Optional context e.g. "Prior Authorization"
 * @param {string} [className] - Optional wrapper class
 */
const AIModeIndicator = ({ mode = AI_MODE.COPILOT, serviceName, className = '' }) => {
  const isCopilot = mode === AI_MODE.COPILOT;
  const label = AI_MODE_LABELS[mode] || (isCopilot ? AI_MODE_LABELS[AI_MODE.COPILOT] : AI_MODE_LABELS[AI_MODE.COWORKER]);

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium ${className}`}
      style={{
        backgroundColor: isCopilot ? '#EFF6FF' : '#F0FDF4',
        color: isCopilot ? '#1D4ED8' : '#166534',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: isCopilot ? '#BFDBFE' : '#BBF7D0',
      }}
      title={isCopilot ? 'You review and approve each suggestion.' : 'Kai runs autonomously; review queue for audit.'}
    >
      {isCopilot ? (
        <Bot className="w-4 h-4 flex-shrink-0" />
      ) : (
        <Zap className="w-4 h-4 flex-shrink-0" />
      )}
      <span>
        {AI_ASSISTANT_NAME}
        {serviceName ? ` · ${serviceName}` : ''}
        <span className="opacity-90"> – {label}</span>
      </span>
    </div>
  );
};

export default AIModeIndicator;
export { AI_MODE };
